const RequiredFieldMarker = ({ className = 'text-danger text-decoration-none ml-1' }) => {
  return (
    <abbr title="Campo obbligatorio" className={className}>
      *
    </abbr>
  );
};

export default RequiredFieldMarker;
